import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getCasinoTournament, getTournamentPlayers } from "../../../../../store/selectors";
import Loader from "../../../../common/Loader";
import PlayerInfo from "../../PlayerInfo";
import HowToPlayPageLink from "../HowToPlayPageLink";
import TournamentGameInfoWidget from "../TournamentGameInfoWidget";
import TournamentGameTimerWidget from "../TournamentGameTimerWidget";
import "./DesktopTournamentGameWidget.scss";

const DesktopTournamentGameWidget = () => {

  const tournament = useSelector(getCasinoTournament);
  const playersList = useSelector(getTournamentPlayers)?.(tournament?.tournamentId);

  if (!tournament || !playersList) return <div className="tournament-game__widget__loader"><Loader size={isMobile ? 'small' : 'large'} /></div>;
  const { endDate } = tournament;
  
  return (
    <div className="tournament-game__widget">
      <div className="tournament-game__widget__info-link-wrapper">
        <HowToPlayPageLink />
      </div>
      <div className="tournament-game__widget__countdown-timer-wrapper">
        <TournamentGameTimerWidget countdownTimestamp={endDate} />
      </div>
      <div className="tournament-game__widget__player-info-wrapper">
        <PlayerInfo />
      </div>
      <div className="tournament-game__widget__players-list-wrapper">
        <TournamentGameInfoWidget />
      </div>
    </div>
  );
};

export default DesktopTournamentGameWidget;
